import { SxProps } from "@mui/material"

export const sxTitle: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "24px",
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left"
}

export const sxBody: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#4C4C4C',
  maxWidth: '540px'
}

export const sxTypographyAdvice: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#4C4C4C',
  width: '100%',
  wordBreak: 'break-word'
}

export const sxButton: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
  '@media(max-width: 768px)': {
    width: '100%'
  }
}